import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Nav, NavItem, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CaptureClicksV2 from '../../components/CaptureClicksV2';
import Image from '../../../shared/components/Image';
import { NavigationSubMenu } from './NavigationSubMenu';
import NavigationContentMenu from './NavigationContentMenu';
import NavIcon from './NavIcon';
import { ROUTE_PREFIXES, SEGMENT_EVENTS } from '../../../shared/Constants';
import { RuntimeContext } from '../../../../common/RuntimeContext';

class MobileNavigation extends Component {
    static propTypes = {
        isVerbAdmin: PropTypes.bool,
        isCompanyReportViewer: PropTypes.bool,
        isVerbReportViewer: PropTypes.bool,
        isAuthenticated: PropTypes.bool,
        loggedInUser: PropTypes.object,
        userCompany: PropTypes.object,
        currentProfile: PropTypes.object,
        activeUserTeams: PropTypes.array,
        // eslint-disable-next-line react/no-unused-prop-types
        location: PropTypes.object.isRequired,
        isMobile: PropTypes.bool,
        isAccountOwner: PropTypes.bool,
        teamsUnsavedFlag: PropTypes.bool,
        history: PropTypes.object,
        handleConfirmationModal: PropTypes.func,
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);

        this.state = {
            adminMenuOpen: false,
            navExpanded: false
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    handleAdminNavToggle = () => {
        this.setState({ adminMenuOpen: !this.state.adminMenuOpen });
    };

    resize = () => this.forceUpdate();

    handleNavigation = (path) => {
        const { teamsUnsavedFlag, history, location, handleConfirmationModal } = this.props;

        const teamsRegex = /^\/admin\/editcompany\/[^\/]+\/teams(\/[^\/]+)?$/;
        const isCurrentPathsTeams = teamsRegex.test(location.pathname);

        if (isCurrentPathsTeams && teamsUnsavedFlag) {
            handleConfirmationModal(true);
        } else {
            history.push(path);
            handleConfirmationModal(false);
            this.setState({ navExpanded: false });
        }
    };

    render() {
        const {
            currentProfile,
            userCompany,
            loggedInUser,
            activeUserTeams,
            isMobile,
            isAuthenticated,
            isVerbAdmin,
            isAccountOwner,
            isCompanyReportViewer,
            isVerbReportViewer,
            location: { pathname }
        } = this.props;

        const explorePageActive = pathname.startsWith(ROUTE_PREFIXES.EXPLORE);

        if (
            window.location.href.includes('welcome/') ||
            window.location.href.includes('learningsampler/')
        ) {
            return null;
        }
        return (
            <CaptureClicksV2>
                <Navbar
                    fixedtop={'true'}
                    className={'topNav mobile-navigation'}
                    expand={'lg'}
                    collapseOnSelect
                    expanded={this.state.navExpanded}
                    onToggle={(navExpanded) => this.setState({ navExpanded })}
                >
                    <div className={'container-custom'}>                        
                        <Nav className={'ms-auto'}>
                            <NavItem>
                                <Nav.Link eventKey={5} href={'/explore'}>
                                    <NavIcon hiddenXS={false} isSelected={explorePageActive} iconClass={'fa-search'} />
                                </Nav.Link>
                            </NavItem>
                        </Nav>

                        <Navbar.Toggle>
                            <i style={{ color: 'white' }} className={'fal fa-bars pull'} />
                        </Navbar.Toggle>
                        <Navbar.Collapse id={'basic-navbar-nav'}>
                            <Nav className={'mobile-dropdown-nav-menu'}>
                                <NavigationContentMenu
                                    userCompany={userCompany}
                                    isVerbAdmin={isVerbAdmin}
                                    isAccountOwner={isAccountOwner}
                                    isCompanyReportViewer={isCompanyReportViewer}
                                    isVerbReportViewer={isVerbReportViewer}
                                    isMobile={isMobile}
                                    pathName={pathname}
                                    loggedInUser={loggedInUser}
                                    activeUserTeams={activeUserTeams}
                                    handleNavigation={this.handleNavigation}
                                />
                                <NavigationSubMenu
                                    currentProfile={currentProfile}
                                    userCompany={userCompany}
                                    activeUserTeams={activeUserTeams}
                                    isAuthenticated={isAuthenticated}
                                    isAccountOwner={isAccountOwner}
                                    isVerbAdmin={isVerbAdmin}
                                    renderForMobile={false}
                                />
                            </Nav>
                        </Navbar.Collapse>
                    </div>
                </Navbar>
            </CaptureClicksV2>
        );
    }
}

export default MobileNavigation;
